import { render, staticRenderFns } from "./TasksPage.vue?vue&type=template&id=36043a46&"
import script from "./TasksPage.vue?vue&type=script&lang=ts&"
export * from "./TasksPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports